<template>
  <div>
    <PageLoader :storage="appLoading" />
    <ServerError v-if="ServerError" />
    
    <v-snackbar v-model="showSnackBar" color="#FF6907" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #fff">{{ msg }}</span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #fff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-layout wrap justify-center>
      <v-flex xs12>
        <v-layout wrap justify-start pa-5>
          <!-- Page Header & Add Button -->
          <v-flex xs12>
            <v-layout wrap justify-space-between align-center>
              <v-flex xs6>
                <span class="heading">Badge Levels</span>
              </v-flex>
              <v-flex xs6 class="text-right">
                <v-btn color="#FF6907" depressed dark @click="openAddDialog()">
                  <span style="color: #fff; font-size: 13px; font-family: poppinssemibold;">
                    Add Level <v-icon right>mdi-plus</v-icon>
                  </span>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>

          <!-- Table List -->
          <v-flex xs12 class="pt-5" v-if="levelsList && levelsList.length > 0">
            <v-card>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-center tableheading">Badge Icon</th>
                      <th class="text-center tableheading">Level Name</th>
                      <th class="text-center tableheading">Min Rescues</th>
                      <th class="text-center tableheading">Action</th>
                    </tr>
                  </thead>
                  <tbody class="tablesubheading">
                    <tr v-for="(item, index) in levelsList" :key="index" class="text-center">
                      <td>
                        <v-avatar size="40" v-if="item.badgeIcon">
                          <img :src="mediaURL + item.badgeIcon" alt="Badge" />
                        </v-avatar>
                        <span v-else>-</span>
                      </td>
                      <td>{{ item.levelName || '-' }}</td>
                      <td>{{ item.minRescues || '-' }}</td>
                      <td>
                        <div class="d-flex align-center justify-center">
                          <v-icon color="green" small @click="openEditDialog(item)">mdi-pencil</v-icon>
                          <v-icon color="red" small class="ml-5" @click="openDeleteDialog(item._id)">mdi-delete</v-icon>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>

      <!-- Pagination -->
      <v-flex xs12 pb-4 v-if="levelsList && levelsList.length > 0">
        <v-layout wrap justify-center>
          <v-flex xs10>
            <v-pagination
              v-model="currentPage"
              :length="pageLength"
              :total-visible="7"
              circle
              color="#FF6907"
              small
            ></v-pagination>
          </v-flex>
        </v-layout>
      </v-flex>

      <!-- Empty State -->
      <v-flex xs12 v-else>
        <v-layout wrap justify-start pl-5>
          <v-flex xs12 class="text-left">
            <span class="heading">No Levels Found!</span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <!-- Add/Edit Modal Dialog -->
    <v-dialog v-model="formDialog" max-width="600" persistent>
      <v-card>
        <v-card-title class="heading">{{ isEditMode ? 'Edit Badge Level' : 'Add Badge Level' }}</v-card-title>
        
        <v-card-text class="pt-4">
          <v-form ref="levelForm" v-model="formValid">
            <v-layout wrap>
              <!-- Level Name Input -->
              <v-flex xs12 px-2>
                <v-text-field
                  label="Level Name *"
                  v-model="form.levelName"
                  :rules="[v => !!v || 'Level Name is required']"
                  outlined
                  dense
                  color="#FF6907"
                />
              </v-flex>

              <!-- Min Rescues Input -->
              <v-flex xs12 px-2>
                <v-text-field
                  label="Min Rescues *"
                  v-model="form.minRescues"
                  type="number"
                  :rules="minRescuesRules"
                  outlined
                  dense
                  color="#FF6907"
                />
              </v-flex>

              <!-- Badge Icon Input -->
              <v-flex xs12 px-2>
               <!-- Clickable Badge Icon Selector -->
                <v-flex xs12 px-2 class="text-center mb-4">
                <span class="subheading d-block mb-2">Badge Icon (1:1 Ratio)</span>
                <div 
                    @click="$refs.badgeFileInput.click()" 
                    style="border: 2px dashed #FF6907; border-radius: 8px; width: 120px; height: 120px; margin: 0 auto; cursor: pointer; display: flex; align-items: center; justify-content: center; overflow: hidden; position: relative;"
                >
                    <!-- 1. Show newly selected cropped preview -->
                    <img v-if="badgeIconPreview" :src="badgeIconPreview" style="width: 100%; height: 100%; object-fit: cover;" />
                    
                    <!-- 2. Else show existing server image if editing -->
                    <img v-else-if="isEditMode && form.badgeIcon" :src="mediaURL + form.badgeIcon" style="width: 100%; height: 100%; object-fit: cover;" />
                    
                    <!-- 3. Default camera icon placeholder -->
                    <v-layout v-else column align-center justify-center>
                    <v-icon size="40" color="grey">mdi-camera-plus-outline</v-icon>
                    <span style="font-size: 11px; color: grey;">Select Badge</span>
                    </v-layout>
                </div>
                
                <!-- Hidden File Input -->
                <input
                    v-show="false"
                    ref="badgeFileInput"
                    type="file"
                    accept="image/*"
                    @change="onFileSelected"
                />
                </v-flex>

              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>

        <v-card-actions class="pb-4 pr-4">
          <v-spacer></v-spacer>
          <v-btn tile outlined color="#FF1313" @click="formDialog = false" class="itemValue">Cancel</v-btn>
          <v-btn tile color="#FF6907" depressed @click="saveLevel()" class="itemValue">
            <span style="color: #fff">Confirm</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete Confirmation Dialog -->
    <v-dialog v-model="deleteDialog" max-width="500">
      <v-card>
        <v-card-title class="heading">Confirmation</v-card-title>
        <v-card-text>Are you sure you want to delete this level?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn tile outlined color="#FF1313" @click="deleteDialog = false" class="itemValue">Cancel</v-btn>
          <v-btn tile color="#FF6907" depressed @click="deleteLevel()" class="itemValue">
            <span style="color: #fff">Confirm</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Image Cropper Dialog -->
    <v-dialog v-model="cropperDialog" max-width="500" persistent>
    <v-card class="pb-3">
        <v-card-title class="heading d-flex justify-space-between align-center">
        <span>Crop Badge Icon</span>
        <v-btn icon @click="cropperDialog = false">
            <v-icon color="red">mdi-close</v-icon>
        </v-btn>
        </v-card-title>
        
        <!-- 1:1 Aspect Ratio Cropper -->
        <v-card-text>
        <Cropper
            ref="cropper"
            :stencil-props="{ aspectRatio: 1 }"
            style="max-height: 400px; width: 100%; background: #ddd;"
            :src="rawImageToCrop"
        />
        </v-card-text>
        
        <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#FF6907" text @click="$refs.badgeFileInput.click()">Change Image</v-btn>
        <v-btn color="#FF6907" depressed dark @click="cropImage">
            <span style="color: #fff">Apply Crop</span>
        </v-btn>
        </v-card-actions>
    </v-card>
    </v-dialog>

  </div>
</template>

<script>
import axios from "axios";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";


export default {
  components: {
    Cropper
  },
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      levelsList: [],
      currentPage: 1,
      pageLength: 0,
      limit: 20,
      formDialog: false,
      deleteDialog: false,
      isEditMode: false,
      deleteId: null,
      formValid: false,
      badgeIconFile: null,
      minRescuesRules: [
        v => !!v || 'Minimum Rescues is required',
        v => parseInt(v) > 0 || 'Minimum Rescues must be greater than 0'
      ],
      form: {
        id: "",
        levelName: "",
        minRescues: ""
      },
      cropperDialog: false,        // Controls visibility of crop dialog
      rawImageToCrop: null,        // Stores the selected image object URL for the cropper
      badgeIconPreview: null,      // Stores cropped base64/URL preview to show in the UI box

    };
  },
  beforeMount() {
    this.getData();
  },
  watch: {
    currentPage() {
      this.getData();
    }
  },
  methods: {
    // 1. GET /level/list
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/level/list",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        },
        params: {
          page: this.currentPage,
          limit: this.limit
        }
      })
      .then(response => {
        this.appLoading = false;
        if (response.data.status === true) {
          this.levelsList = response.data.data;
          this.pageLength = response.data.pages || 1;
        } else {
          this.levelsList = [];
          this.msg = response.data.msg;
          this.showSnackBar = true;
        }
      })
      .catch(err => {
        this.appLoading = false;
        this.ServerError = true;
        console.error(err);
      });
    },

    // Dialog Toggles
   openAddDialog() {
    this.isEditMode = false;
    this.badgeIconFile = null;
    this.badgeIconPreview = null; // Clear cropped preview
    this.rawImageToCrop = null;   // Clear cropper source
    this.form = { id: "", levelName: "", minRescues: "" };
    if (this.$refs.levelForm) {
        this.$refs.levelForm.resetValidation();
    }
    this.formDialog = true;
    },
    openEditDialog(item) {
        this.isEditMode = true;
        this.badgeIconFile = null;
        this.badgeIconPreview = null; // Clear cropped preview
        this.rawImageToCrop = null;   // Clear cropper source
        this.form = {
            id: item._id,
            levelName: item.levelName,
            minRescues: item.minRescues,
            badgeIcon: item.badgeIcon   // Bind existing badge icon name
        };
        if (this.$refs.levelForm) {
            this.$refs.levelForm.resetValidation();
        }
        this.formDialog = true;
    },
    openDeleteDialog(id) {
      this.deleteId = id;
      this.deleteDialog = true;
    },

    // 2. POST /level/add and /level/edit
    saveLevel() {
      if (!this.$refs.levelForm.validate()) {
        return;
      }
      this.appLoading = true;

      // Construct Multipart/FormData payload
      const formData = new FormData();
      formData.append("levelName", this.form.levelName);
      formData.append("minRescues", this.form.minRescues);
      
      if (this.badgeIconFile) {
        formData.append("badgeIcon", this.badgeIconFile);
      }

      if (this.isEditMode) {
        formData.append("id", this.form.id);
      }

      const url = this.isEditMode ? "/level/edit" : "/level/add";

      axios({
        method: "POST",
        url: url,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
          "Content-Type": "multipart/form-data"
        },
        data: formData
      })
      .then(response => {
        this.appLoading = false;
        if (response.data.status === true) {
          this.msg = this.isEditMode ? "Level edited successfully." : "Level added successfully.";
          this.showSnackBar = true;
          this.formDialog = false;
          this.getData();
        } else {
          this.msg = response.data.msg;
          this.showSnackBar = true;
        }
      })
      .catch(err => {
        this.appLoading = false;
        if (err.response && err.response.data && err.response.data.msg) {
          this.msg = err.response.data.msg;
          this.showSnackBar = true;
        } else {
          this.ServerError = true;
        }
        console.error(err);
      });
    },

    // 3. POST /level/delete (Urlencoded payload)
    deleteLevel() {
      this.appLoading = true;

      // Create urlencoded body payload
      const payload = new URLSearchParams();
      payload.append("id", this.deleteId);

      axios({
        method: "POST",
        url: "/level/delete",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: payload
      })
      .then(response => {
        this.appLoading = false;
        if (response.data.status === true) {
          this.msg = "Level deleted successfully.";
          this.showSnackBar = true;
          this.deleteDialog = false;
          this.getData();
        } else {
          this.msg = response.data.msg;
          this.showSnackBar = true;
          this.deleteDialog = false;
        }
      })
      .catch(err => {
        this.appLoading = false;
        if (err.response && err.response.data && err.response.data.msg) {
          this.msg = err.response.data.msg;
          this.showSnackBar = true;
        } else {
          this.ServerError = true;
        }
        console.error(err);
      });
    },

    onFileSelected(event) {
        const file = event.target.files[0];
        if (!file) return;
        if (file.size > 3 * 1024 * 1024) { // 3MB Limit
            this.msg = "File size should be less than 3MB";
            this.showSnackBar = true;
            return;
        }
        
        this.rawImageToCrop = URL.createObjectURL(file);
        this.cropperDialog = true;
    },

    cropImage() {
      const canvas = this.$refs.cropper.getResult().canvas;
      if (canvas) {
        const base64Data = canvas.toDataURL("image/jpeg", 0.8);
        this.badgeIconPreview = base64Data; // Used for UI Preview box
            
        // Convert to a File object for multipart/form-data upload
        this.badgeIconFile = this.dataURLtoFile(base64Data, "badge-icon.jpg");
        this.cropperDialog = false;
      }
    },

    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
  }
};
</script>

<style>
.heading {
  font-family: poppinsregular;
  font-size: 20px;
  font-weight: 900;
}
.subheading {
  font-family: poppinsregular;
  font-size: 15px;
  font-weight: 500;
}
.tableheading {
  font-family: poppinsregular;
  font-size: 15px !important;
  color: black !important;
  text-transform: uppercase !important;
}
.tablesubheading {
  font-family: poppinsregular;
  font-size: 10px;
}
</style>
